export default __webpack_public_path__ + "static/media/react-native-todo.a60b9665.png";